import keyMirror from 'fbjs/lib/keyMirror';

/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const WorkflowConstants = keyMirror({
  CHECKIN_ACTION: undefined,
  NEXT_ACTION: undefined,
  PREVIOUS_ACTION: undefined,
  ADDTIONAL_SAVING_AMOUNT: undefined,
});



// WEBPACK FOOTER //
// ./src/constants/workflowConstants.js